<template>
<Transition name="loading-fade">
    <div
        v-if="visible"
        id="ShinaiLoading"
        role="status"
        aria-live="polite"
        aria-label="Загрузка контента"
    >
        <div class="loading-mark" aria-hidden="true">
            <span class="circle circle-large"></span>
            <span class="circle circle-small"></span>
        </div>
    </div>
</Transition>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'ShinaiLoading',
    data() {
        return {
            visible: false,
            hideTimer: null
        }
    },
    computed: {
        ...mapGetters(['get_loading_active']),
        currentPageLoading() {
            return this.get_loading_active(this.$route.fullPath)
        }
    },
    watch: {
        currentPageLoading: {
            immediate: true,
            handler(isLoading) {
                clearTimeout(this.hideTimer)
                if (isLoading) {
                    this.visible = true
                    return
                }
                this.hideTimer = setTimeout(() => {
                    this.visible = false
                }, 220)
            }
        }
    },
    beforeUnmount() {
        clearTimeout(this.hideTimer)
    }
}
</script>

<style scoped>
#ShinaiLoading {
    position: fixed;
    z-index: 40;
    top: 16px;
    right: 20px;
    top: max(16px, env(safe-area-inset-top, 0px));
    right: max(20px, env(safe-area-inset-right, 0px));
    width: 40px;
    height: 36px;
    pointer-events: none;
}
.loading-mark {
    position: relative;
    width: 100%;
    height: 100%;
    isolation: isolate;
}
.circle {
    position: absolute;
    display: block;
    border-radius: 50%;
    box-shadow: 0 4px 12px rgba(255, 35, 35, 0.42);
}
.circle-large {
    z-index: 2;
    top: 3px;
    left: 9px;
    width: 26px;
    height: 26px;
    background: radial-gradient(94.49% 94.49% at 81.76% 20.59%, #d40000 0%, #ff3e3e 100%);
    animation: loading-large-arrive 1.5s ease-in-out both;
}
.circle-small {
    z-index: 1;
    top: 16px;
    left: 6px;
    width: 16px;
    height: 16px;
    background: radial-gradient(131.18% 131.18% at 100% 0%, #9a0303 0%, #be3232 100%);
    animation: loading-small-arrive 1s cubic-bezier(0.2, 0.68, 0.28, 1) both;
}
.loading-fade-leave-active {
    transition: opacity 280ms ease, transform 280ms ease;
}
.loading-fade-leave-to {
    opacity: 0;
    transform: translateY(-6px) scale(0.82);
}

@keyframes loading-large-arrive {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.18); }
}
@keyframes loading-small-arrive {
    from {
        transform: rotate(180deg) translateX(42px) rotate(-1800deg) scale(0);
    }
    to {
        transform: rotate(360deg) translateX(0) rotate(-360deg) scale(1);
    }
}

@media (max-width: 1000px) {
    #ShinaiLoading {
        top: max(12px, env(safe-area-inset-top, 0px));
        right: max(14px, env(safe-area-inset-right, 0px));
        transform: scale(0.88);
        transform-origin: top right;
    }
}
@media (prefers-reduced-motion: reduce) {
    .circle-large,
    .circle-small { animation: none; }
    .loading-fade-leave-active { transition: opacity 150ms ease; }
}
</style>
